import { fillArray } from '../utils/array';

export default (state = {}, action = {}) => {
	if (action.type === 'PAGE_LOADING') {
		return {
			...state,
			loading: true,
			seed: fillArray(50, Math.random),
			initiated: action.initiated,
		};
	}

	if (action.type === 'PAGE_LOADED') {
		return {
			...state,
			loading: false,
			pageType: action.pageType || state.pageType,
			paths: {
				...state.paths,
				...action.paths,
			},
		};
	}

	return state;
};
